import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Grid2 from '@mui/material/Grid2';

const ActionCards = ({ actions, onActionClick }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid2 container spacing={{ xs: 2, sm: 4 }}>
            {actions.map((action, index) => (
                <Grid2 size={{ xs: 6, md: 3 }} key={index}>
                    <Box
                        onClick={() => onActionClick(action.id)}
                        sx={{
                            padding: isMobile ? '22px 14px' : '32px 20px',
                            borderRadius: '12px',
                            backgroundColor: '#f5f5f5',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            transition: 'all 0.15s ease',
                            border: '1px solid transparent',
                            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
                            '&:hover': {
                                backgroundColor: '#ededee',
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
                                borderColor: '#e0e0e0',
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <Box
                            sx={{
                                mb: isMobile ? 0 : '10px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: '#0a0b0d',
                            }}
                        >
                            {action.icon}
                        </Box>
                        <Typography
                            align="center"
                            sx={{
                                fontWeight: 500,
                                color: '#0a0b0d',
                                fontSize: isMobile ? '0.85rem' : '0.95rem',
                            }}
                        >
                            {action.label}
                        </Typography>
                    </Box>
                </Grid2>
            ))}
        </Grid2>
    );
};

export default ActionCards;
